import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog.jsx";

import TaskPreview from "./TaskPreview";

const TaskViewDialog = ({ task, isOpen, onClose }) => {
  if (!task) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md p-0 overflow-hidden border-none shadow-2xl rounded-xl">
        <DialogHeader className="px-5 pt-5 pb-0">
          <DialogTitle className="text-yale-blue-500 text-xs uppercase tracking-widest font-bold">Task Overview</DialogTitle>
        </DialogHeader>
        <TaskPreview task={task} />
      </DialogContent>
    </Dialog>
  );
};

export default TaskViewDialog;
